import { configureStore } from '@reduxjs/toolkit';
import advisorReducer from './advisor/advisorSlice';
import clientSlice from './client/clientSlice';
import calendarReducer from './client/calendarSlice'

const store = configureStore({
  reducer: {
    advisor: advisorReducer,
    client: clientSlice,
    calendar: calendarReducer,
  },
});

export default store;
